<main id="main-content" class="grid nested-grid ">
    <div class="col-12 mt-4 px-6">
        <h1>Modify Airman / Operator / Aircraft Registered Owner Details</h1>
        <div class="p-5 bg-cyan-50 border-300">
            <app-searchpanel searchType="EditOperator" (searchResults)="handleSearch($event)" (resetPagination) = "handleResetPagination($event)" (isAirmenAgentSearch) = "IsSearchTypeAirmen($event)" [onPageChange]="onPageChange" [sortOrder]="sortOrder"></app-searchpanel>
        </div>
        <div>
            <app-admin-search-results [resetPagination]="resetPagination" [isAirmenAgentSearch] = "isAirmenAgentSearch" [searchResults]="searchResults" [columns]="columns"
            (pageChange)="handlePageChange($event)" (sortOrderForSearch)="sortOrderForSearch($event)"></app-admin-search-results>
        </div>
    </div>
</main>
